<template>
  <v-col>
    <v-row>
      <v-col
        :key="index"
        v-for="(kind, index) in counting"
      >
        <v-card>
          <v-card-text>
            <h3>{{kind.count}} <span class="primary--text">{{kind.brand}}</span></h3>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row justify="end">
          <v-btn
            color="primary"
            class="mb-6 mr-3"
            @click="downloaGiacenza"
          >Scarica XLS Giacenze</v-btn>
        </v-row>
        <v-card>
          <v-card-title class="pb-8">
            <v-btn
              color="primary"
              @click="CHANGE_SIM_COMPONENT('Insert')"
            >Nuova Sim</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="sims"
            class="elevation-1"
            :search="search"
            :items-per-page="100"
            :footer-props="{
      itemsPerPageAllText: 'Tutti',
      itemsPerPageOptions: [15, 50, 100, -1],
      itemsPerPageText: 'Sim per pagina',
    }"
          >
            <template v-slot:top>
              <edit-form
                :item="selectedItem"
                @edit-submit="triggerSnack($event)"
              />
            </template>

            <template v-slot:item.action="{ item }">
              <td class="actions">
                <v-btn
                  color="orange"
                  elevation="1"
                  outlined
                  small
                  @click.stop="edit(item)"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  color="red"
                  elevation="1"
                  outlined
                  small
                  @click.stop="triggerDialog(item)"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
            </template>

            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="fetchSims"
              >Ricarica</v-btn>
            </template>

            <template v-slot:item.cost="{ item }">
              <span>{{item.cost || '0'}}€</span>
            </template>

            <template v-slot:item.price="{ item }">
              <span>{{item.price || '0'}}€</span>
            </template>

            <template v-slot:item.posix="{ item }">
              <span>{{new Date(item.posix).toLocaleString('it-IT', {'day': '2-digit', 'month': '2-digit', 'year': 'numeric', })}}</span>
            </template>
          </v-data-table>
          <snack-notification :snack="snack" />
        </v-card>
      </v-col>
    </v-row>

    <!-- dialog -->

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Cancellare articolo?</v-card-title>

          <v-card-text>
            Confermando, il prodotto selezionato verrà eliminato dal magazzino.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="remove()"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Index',
    components: {
      EditForm,
      SnackNotification
    },
    data: () => ({
      today: `${(new Date()).getDate()}-${(new Date()).getMonth() + 1}-${(new Date()).getFullYear()}`,
      search: '',
      dialog: false,
      headers: [
        { text: 'Operatore', value: 'brand', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Seriale', value: 'serial_number', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Costo', value: 'cost', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Acquistata il', value: 'posix', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
      ],
      sims: [],
      counting: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_SIM_COMPONENT',
        'CHANGE_SIM_EDIT'
      ]),

      async fetchSims() {
        try {

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/sims/fetch`, this.config)

          console.log(data)

          this.sims = data.sims
          this.counting = data.counting
        } catch (error) {

          console.log(error)

          this.sims = []
        }
      },

      async downloaGiacenza() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/downloads/giacenza-sims`, this.config)

        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')

        const name = `[${this.today}]report_giacenze_sims.xls`

        fileLink.href = fileURL
        fileLink.setAttribute('download', name)
        document.body.appendChild(fileLink)

        fileLink.click()
      },

      edit(val) {

        this.item = val
        this.CHANGE_SIM_EDIT(true)
      },

      async remove() {

        const { data } = await axios.post(`${process.env.VUE_APP_API}/sims/delete`, this.item, this.config)

        if (data.status) {
          this.fetchSims()
          this.dialog = false
        } else {
          alert('Si è verificato un errore.')
        }
      },

      triggerDialog(val) {
        this.item = val
        this.dialog = true
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Articolo modificato correttamente!'
          })
        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      }
    },

    async created() {
      await this.fetchSims()
    },
  }
</script>

<style scoped>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>